// @flow

import {Form} from './form';

export class FormDealer
{
	#app;
	constructor(rootNode): void
	{
		this.rootNode = document.querySelector(rootNode);
	}

	start(): void
	{
		if (this.rootNode)
		{
			this.attachTemplate();
		}
	}

	attachTemplate(): void
	{
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			template: `
				<div>
					<Form/>
				</div>
				`
		});
		this.#app.mount(this.rootNode);
	}
}
